export const selectModalOpen = state => state.modal.isOpen;
export const selectModalContent = state => state.modal.content;
